"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.experimentsSpecMap = void 0;
exports.experimentsSpecMap = {
    IS_NEW_BOOKINGS_MEMBERS_AREA_INSTALLED: 'specs.bookings.isNewBookingsMembersAreaInstalled',
};
//# sourceMappingURL=experimentsSpecMap.js.map